import { InputAdornment } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TbInfoCircle, TbNotes, TbUserHexagon } from "react-icons/tb";

import { CommonHelperText, CommonInput, CommonLabel } from "@/components/CommonInput";
import CompanionsField from "@/components/CompanionsField";

import { CreatePassengerForm } from "./CreateCustomPassengerDialog";

function CreateUserFormInfo({ loading, handleResetLatency }: { loading: boolean; handleResetLatency: () => void }) {
    const { t } = useTranslation();
    const {
        register,
        formState: { errors },
    } = useFormContext<CreatePassengerForm>();

    return (
        <>
            <span className="text-sm text-gray-500 col-span-full pl-6 flex gap-1  pb-4 items-center">
                <TbInfoCircle fontSize={16} />
                Yolcunun kişisel bilgilerini doldurunuz.
            </span>
            <div className="grid grid-cols-8   gap-6">
                <CommonLabel required label={t("passengerFullName")} labelClass="!px-8" className=" col-span-6 !px-6">
                    <CommonInput
                        disabled={loading}
                        error={!!errors?.step1?.name}
                        {...register("step1.name")}
                        placeholder={t("placeholders.enter", { field: t("passengerFullName") })}
                        startAdornment={
                            <InputAdornment position="start">
                                <TbUserHexagon />
                            </InputAdornment>
                        }
                    />
                    <CommonHelperText text={errors?.step1?.name?.message || ""} />
                </CommonLabel>

                <CompanionsField<CreatePassengerForm>
                    handleResetLatency={handleResetLatency}
                    formPath="step1.companions"
                    loading={loading}
                />

                <CommonLabel label={t("note")} labelClass="!px-8" className=" !px-6 col-span-10">
                    <CommonInput
                        disabled={loading}
                        placeholder={t("placeholders.enter", { field: t("note") })}
                        multiline
                        {...register("step1.note")}
                        rows={3}
                        classes={{
                            root: "!py-2",
                        }}
                        error={!!errors?.step1?.note}
                        endAdornment={
                            <InputAdornment position="end">
                                <TbNotes />
                            </InputAdornment>
                        }
                    ></CommonInput>
                </CommonLabel>
            </div>
        </>
    );
}

export default CreateUserFormInfo;
